export default {
  builder: {
    heroTitlePre: 'GPAX Builder:',
    heroTitlePost: 'Interoperate your systems quickly and efficiently',
    interoperateTitle: 'Interoperate with:',
    interoperateDesc: 'GPAX Builder interoperates with systems without requiring changes.',
    dbTitle: 'Databases:',
    dbText: 'Oracle, SQL Server, Sybase, MongoDB, others.',
    legacyTitle: 'Legacy system:',
    legacyText: 'Cobol, RPG, AS/400, Series A, others.',
    appsTitle: 'Applications:',
    appsText: 'Desktop, web, Api, SOA, WSE, SAP, others.',
    devicesTitle: 'Devices:',
    devicesText: 'Drones, access control systems, PDAs, ATM.',
    filesTitle: 'Files:',
    filesText: 'MS Excel, CSV, SFTP, FTP, others.',
    complementTitle: 'Complement with:',
    complementDesc: 'GPAX Builder has specialized components that speed up your development process.',
    complement1: 'Geoviewer and data mining.',
    complement2: 'Resource monitoring and Universal Client.',
    complement3: 'Traceability and governance.',
    complement4: 'Indicators, reports and automation (RPA).',
    complement5: 'Visual procedure designer.',
    benefit1Title: 'Interoperability',
    benefit1Desc: 'Creating a digital ecosystem for the organization.',
    benefit2Title: 'Real-time development',
    benefit2Desc: 'Co-create new solutions together with the users who own the process.',
    benefit3Title: 'Low-code platform',
    benefit3Desc: 'It does not require knowledge of existing languages.',
    benefit4Title: 'Reliability and stability',
    benefit4Desc: 'Of your applications on a new digital platform.',
    benefit5Title: 'BPMN 2.0 standard',
    benefit5Desc: 'To model processes.',
    benefit6Title: 'High impact',
    benefit6Desc: 'In a short time.',
    servicesTitle: 'Services',
    service1: 'We orchestrate business processes.',
    service2: 'Application intermediation and integration.',
    service3: 'End-to-end application development.',
    service4: 'Data mining.',
    service5: 'Data reduction and consolidation.',
    service6: 'Last-mile connectivity and RPA.',
    service7: 'Creation and monitoring of indicators with notifications.',
    service8: 'Data migration and analysis.',
    storiesTitle: 'Success stories',
    tabMunicipality: 'Municipality',
    tabBpo: 'BPO Call Center',
    tabFinancial: 'Financial Institution',
    problem: 'Problem',
    solution: 'Solution',
    result: 'Result',
    stories: {
      municipality: {
        problem: [
          { label: '12 systems', text: 'isolated from each other while handling citizen services.' },
          { label: '48h', text: 'average wait to resolve a resident request.' },
        ],
        solution: [
          { label: '', text: 'Municipal platforms are integrated with GPAX Builder, without modifying them.' },
          { label: '', text: 'The service is orchestrated with the visual procedure designer.' },
          { label: '', text: 'The citizen tracks their request from a single portal.' },
        ],
        result: [
          { label: '3 months', text: 'to launch the new service flow.' },
          { label: '80%', text: 'reduction in citizen response times.' },
        ],
      },
      bpo: {
        problem: [
          { label: '9 screens', text: 'that the agent had to open to handle a single call.' },
          { label: '7 min', text: 'average handling time per call.' },
        ],
        solution: [
          { label: '', text: "The client's systems are unified into a single agent screen." },
          { label: '', text: "GPAX Builder validates the customer's identity and status in real time." },
          { label: '', text: 'Campaigns connect via API and SFTP using the specialized components.' },
        ],
        result: [
          { label: '4 weeks', text: 'of implementation alongside the operations team.' },
          { label: '45%', text: 'reduction in average call handling time.' },
        ],
      },
      financial: {
        problem: [
          { label: '600 TPS', text: '(transaction requests) from its external collectors.' },
          { label: '5 TPS', text: '(transaction requests) capacity in its current system.' },
        ],
        solution: [
          { label: '', text: 'A virtual cache of data from the current system is created.' },
          { label: '', text: 'Each collector transaction is validated and approved against the cache.' },
          { label: '', text: 'Another process synchronizes with the current system.' },
        ],
        result: [
          { label: '100h', text: 'to develop the solution.' },
          { label: '6h', text: 'after peak hour the system is synchronized.' },
        ],
      },
    },
    ctaTitle: 'Want to know more about us?',
    contact: 'Contact us',
  },
};